import React, { useEffect, useReducer } from "react";
import { getPosts, getPostMedia, getCategories } from "../../api/post";
import { Helmet } from "react-helmet";

import { getPages } from "../../api/page";
import Loading from "../../components/loading";
import { HomeContainer } from "./style";
import PostBox from "../../components/postbox";
import ProductSlide from "../../components/productSlideOld";
import { FiX } from "react-icons/fi";
function reducer(state, action) {
  switch (action.type) {
    case "setPosts":
      return {
        ...state,
        posts: action.payload.posts,
        pages: action.payload.pages,
        categories: action.payload.categories,
        loading: false,
      };
    case "setShowingPage":
      return {
        ...state,
        showingPage: action.payload,
      };
    case "setSelectedCategory":
      return {
        ...state,
        selectedCategory: action.payload,
      };
    default:
      return state;
  }
}
const Home = () => {
  const [state, dispatch] = useReducer(reducer, {
    posts: [],
    pages: [],
    categories: [],
    showingPage: null,
    loading: true,
    selectedCategory: 0,
  });
  const [slideStatus, setSlideStatus] = React.useState(false);
  useEffect(() => {
    const getData = async () => {
      let fetchedPosts = [];
      let fetchedPages = [];
      let fetchedCategories = [];
      await getPosts({ per_page: 100 })
        .then((res) => {
          fetchedPosts = res.data;
        })
        .catch((err) => {});
      if (fetchedPosts.length > 0) {
        let fetches = fetchedPosts.map(async (post, index) => {
          if (post.featured_media) {
            await getPostMedia(post.featured_media).then((res) => {
              fetchedPosts[index]["cover"] = {
                url: res.data.source_url,
                alt: res.data.alt_text,
              };
            });
          }
        });
        fetches.push(
          getPages().then((res) => {
            fetchedPages = res.data;
          })
        );
        fetches.push(
          getCategories().then((res) => {
            fetchedCategories = res.data;
          })
        );
        await Promise.all(fetches);
      }
      dispatch({
        type: "setPosts",
        payload: {
          posts: fetchedPosts,
          pages: fetchedPages,
          categories: fetchedCategories,
        },
      });
    };
    getData();
  }, []);
  const pageView = () => {
    if (state.showingPage) {
      return (
        <div className="page-view">
          <div className="back">
            <FiX
              onClick={() =>
                dispatch({ type: "setShowingPage", payload: null })
              }
            />
          </div>
          <h2>
            {state.showingPage.title && state.showingPage.title.rendered
              ? state.showingPage.title.rendered
              : null}
          </h2>
          {state.showingPage.content && state.showingPage.content.rendered ? (
            <div
              dangerouslySetInnerHTML={{
                __html: state.showingPage.content?.rendered,
              }}
            />
          ) : null}
        </div>
      );
    }
  };
  return (
    <HomeContainer className="container" showingPage={state.showingPage}>
      <Loading loading={state.loading} />
      <Helmet>
        <title>Black Monolith</title>
        <meta
          name="description"
          content="Black Monolith creative studio is an organized whole of directors, designers, and experts specializing in
3D motion design, 2D motion design, composition, and film editing."
        />
      </Helmet>
      <div className="menu">
        <video autoPlay loop muted className="logo-video">
          <source src="./animate/logoloop.mp4" type="video/mp4" />
        </video>
        <img src="./animate/logoloop.gif" alt="logo" className="logo-gif" />
        <ul>
          {state.pages.map((page) => {
            return (
              <li
                key={page.id}
                onClick={() =>
                  dispatch({ type: "setShowingPage", payload: page })
                }
              >
                {/* <Link to={`/page/${page.slug}`}>{page.title?.rendered}</Link> */}
                {page.title?.rendered}
              </li>
            );
          })}
        </ul>
        <div className="separator">
          <svg height="10000" width="1">
            <line
              className="slowTransition"
              x1="0"
              y1="0"
              x2="0"
              y2="10000"
            ></line>
          </svg>
        </div>
      </div>
      <div className="content">
        <div className="page">{pageView()}</div>
        <div className="posts">
          <div className="categories">
            <div
              className={`category ${
                state.selectedCategory === 0 ? "selected" : ""
              }`}
              onClick={() =>
                dispatch({
                  type: "setSelectedCategory",
                  payload: 0,
                })
              }
            >
              All
            </div>
            {state.categories.map((category) => (
              <div
                className={`category ${
                  state.selectedCategory === category.id ? "selected" : ""
                }`}
                onClick={() =>
                  dispatch({
                    type: "setSelectedCategory",
                    payload: category.id,
                  })
                }
                key={category.id}
                dangerouslySetInnerHTML={{
                  __html: category.name,
                }}
              />
            ))}
          </div>
          <div className="masonry">
            {state.posts.map((post) => {
              if (post.status !== "publish" || post.categories.length === 0) {
                return null;
              } else {
                if (
                  state.selectedCategory !== 0 &&
                  post.categories.indexOf(state.selectedCategory) === -1
                ) {
                  return null;
                } else {
                  return (
                    <PostBox
                      post={post}
                      key={post.id}
                      onClick={() => {
                        setSlideStatus(post);
                      }}
                    />
                  );
                }
              }
            })}
          </div>
        </div>
      </div>
      <ProductSlide
        post={slideStatus}
        resetPost={() => setSlideStatus(false)}
      />
    </HomeContainer>
  );
};
export default Home;
